<template>
  <div>
    <div class="text-subtitle mb-4">Modifier les informations du module</div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="module.nom" label="Nom du module"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="module.date_debut_inscription" type="date"
          label="Date d'ouverture des inscriptions"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="module.heure_debut_inscription" type="time"
          label="Heure d'ouverture des inscriptions"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="module.date_fin_inscription" type="date"
          label="Date de fermeture des inscriptions"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="module.heure_fin_inscription" type="time"
          label="Heure de fermeture des inscriptions"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <label class="field_label">Réglement du module</label>
        <div v-if="module.url_reglement != ''" class="d-flex justify-space-between align-center">
          <v-chip color="dark-green" class="mb-1" v-if="module.url_reglement" prepend-icon="mdi-check"><a
              class="text-dark-green" :href="module.url_reglement" target="_blank">Fichier importé avec
              succès</a></v-chip>
          <v-btn variant="plain" density="compact" v-if="!change_reglement" @click="change_reglement = true">Remplacer
            le fichier ?</v-btn>
        </div>
        <v-file-input v-if="change_reglement || module.url_reglement == ''" density="compact"
          accept="image/*,.pdf,.doc,.docx" @update:modelValue="upload_file_reglement"
          :error-messages="error_reglement"></v-file-input>
      </v-col>
      <v-col cols="12" md="6">
        <label class="field_label">Flyer du module</label>
        <div v-if="module.url_flyer != ''" class="d-flex justify-space-between align-center">
          <img v-if="module.url_flyer != ''" :src="module.url_flyer" alt="" style="height: 100px; width: auto" />
          <v-btn variant="plain" density="compact" v-if="!change_flyer" @click="change_flyer = true">Remplacer le
            fichier ?</v-btn>
        </div>
        <v-file-input v-if="change_flyer || module.url_flyer == ''" density="compact" accept="image/*,.pdf,.doc,.docx"
          @update:modelValue="upload_file_flyer" :error-messages="error_flyer"></v-file-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary-dark" @click="update_config()" :loading="loading" class="mt-4" block>Enregistrer les
          modifications</v-btn>
      </v-col>
    </v-row>
    <div v-if="mainStore.authAdmin.isSportipsAdmin">
      <hr />
      <div class="text-h6">Historique des modifications</div>
      <ConfigHistory v-if="module.id" action="config_module" :id="module.id" :key="lastFetch"></ConfigHistory>
    </div>

    <v-snackbar v-model="show_snackbar" location="top right" color="dark-green">
      Mise à jour effectuée avec succès !

      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="show_snackbar = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import Module from "@/classes/Module/Module.class";
import ConfigHistory from "@/components/Administration/ConfigurationModule/ConfigHistory.vue";

export default {
  components: { ConfigHistory },
  data() {
    return {
      module: new Module(),
      loading: false,
      show_snackbar: false,
      change_reglement: false,
      change_flyer: false,
      error_reglement: "",
      
      error_flyer: "",
      lastFetch: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async update_config() {
      this.loading = true;
      await this.module.update_config();
      this.loading = false;
      this.show_snackbar = true;
      this.lastFetch = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    },
    async upload_file_reglement(file) {
      let response = await this.module.upload_reglement(file);
      if (!response.success) {
        this.error_reglement = response.message;
      }
    },
    async upload_file_flyer(file) {
      let response = await this.module.upload_flyer(file);
      if (!response.success) {
        this.error_flyer = response.message;
      }
    },
  },
  async mounted() {
    this.module.base = this.mainStore.module.base;
    await this.module.fetch();
  },
};
</script>

<style lang="sass" scoped>
</style>